import { CreateDailyRateInsuranceFeeDto } from './create-daily-rate-insurance-fee.dto';
export class UpdateDailyRateInsuranceFeeDto extends CreateDailyRateInsuranceFeeDto {
}
